import React, { useState, useEffect, useMemo } from 'react'; //, useMemo
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Form, Space, Row, Spin, Input, Select } from 'antd'; // message,, Typography
import styles from './index.module.less';
import FormItem from 'common/FormItem';
//import CustomButton from '@/common/CustomButton';
import { history } from '@/app/history';
import {
  //create_bu_master,
  get_all_users,
  //get_RO_Master,
  create_or_update_project_site,
  get_BU_Master
} from '../../../../redux/slice';
import { debounce } from 'lodash';
import FormData from 'form-data';

//const { TextArea } = Input;
const { Option } = Select;

function CreateProjectSiteFlows() {
  TabTitle('Gift Register - Create New RO Flow');

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState({});
  const [allUsersSearch, setAllUsersSearch] = useState('');
  //const [allLocationSearch, setAllLocationSearch] = useState('');
  const [locationName, setLocationName] = useState('');
  const [locationAddress, setLocationAddress] = useState('');
  const [buSearch, setBuSearch] = useState('');
  const [selectedBu, setSelectedBu] = useState(null);
  const [selectedSbu, setSelectedSbu] = useState(null);
  const [selectedSbg, setSelectedSbg] = useState(null);
  const {
    get_all_usersLoading,
    all_users_List,
    //create_bu_masterLoading,
    create_or_update_project_siteLoading,
    ro_MasterList,
    bu_MasterList
  } = useSelector((state) => state.admin);
  console.log('all_users_List', all_users_List);
  console.log('bu_MasterList', bu_MasterList);

  useEffect(() => {
    const payload = {};
    if (allUsersSearch) payload['search'] = allUsersSearch;
    dispatch(get_all_users(payload));
  }, [allUsersSearch]);
  useEffect(() => {
    const payload = {};
    if (buSearch) payload['search'] = buSearch;
    dispatch(get_BU_Master(payload));
  }, [buSearch]);

  const debounceFetcherUserId = useMemo(() => {
    const loadOptions = (allUsersSearch) => {
      setAllUsersSearch(allUsersSearch);
    };
    return debounce(loadOptions, 400);
  }, []);

  const debounceFetcherBuId = useMemo(() => {
    const loadOptions = (buSearch) => {
      setBuSearch(buSearch);
    };
    return debounce(loadOptions, 400);
  }, []);

  // useEffect(() => {
  //   const payload = {};
  //   if (allLocationSearch) payload['search'] = allLocationSearch;
  //   dispatch(get_RO_Master(payload)).then(function (response) {
  //     if (response?.payload?.success) {
  //       console.log('response?.payload?.data', response?.payload?.data);
  //     }
  //   });
  // }, [allLocationSearch]);

  // const debounceFetcherallLocationSearch = useMemo(() => {
  //   const loadOptions = (allLocationSearch) => {
  //     setAllLocationSearch(allLocationSearch);
  //   };
  //   return debounce(loadOptions, 400);
  // }, []);

  useEffect(() => {
    let locationValues = ro_MasterList?.filter(
      (item) => item?.id === formValues?.locationName
    );
    console.log('locationValues', locationValues);
    setLocationName(locationValues[0]?.location);
    setLocationAddress(locationValues[0]?.locationAddress);
  }, [formValues?.locationName]);

  console.log('LocationName', locationName);
  console.log('LocationAddress', locationAddress);

  // const handleFormDataOnChange = (slug, value) => {

  //   console.log('slug,value:', slug, value);

  //   setFormValues({
  //     ...formValues,
  //     [slug]: value
  //   });
  // };

  const handleFormDataOnChange = (slug, value) => {
    if (slug === 'buId') {
      const buObj = bu_MasterList?.find((bu) => bu.id === value);

      setSelectedBu(value);

      // Auto-select SBU & SBG
      setSelectedSbu(buObj?.Sbus?.id || null);
      setSelectedSbg(buObj?.Sbus?.Sbg?.id || null);
    }

    setFormValues((prev) => ({
      ...prev,
      [slug]: value
    }));
  };

  const onFinish = () => {
    let formdata = new FormData();
    //formdata.append('id', formValues?.projectHeadId === undefined ? '' : formValues?.projectHeadId);
    formdata.append(
      'name',
      formValues?.projectSiteName === undefined
        ? ''
        : formValues?.projectSiteName
    );
    formdata.append(
      'InchargeId',
      formValues?.projectHeadId === undefined ? '' : formValues?.projectHeadId
    );
    formdata.append(
      'BuMasterId',
      formValues?.buId === undefined ? '' : formValues?.buId
    );
    dispatch(create_or_update_project_site(formdata)).then(function (response) {
      if (response?.payload?.success) {
        history.push('/project-site-flow');
      }
    });
  };
  const selectedBuObj = bu_MasterList?.find((bu) => bu.id === selectedBu);

  return (
    <CustomLayout>
      <Spin spinning={get_all_usersLoading}>
        <div style={{ marginTop: '50px' }}>
          <Row className={`${styles.row_container_setting}`}>
            <div className={`${styles.gift_container}`}>
              <div className={`${styles.myGift_title_setting}`}>
                Add Project Site
              </div>
            </div>
          </Row>{' '}
          <div className={`${styles.container}`}>
            <div className={`${styles.cardContainer}`}>
              <Card className={`${styles.cardStyles_Container}`}>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className={`${styles.formstyles}`}
                >
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Enter Project Site Name
                          </div>
                        }
                        name="projectSiteName"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          value={locationAddress}
                          className={`${styles.margin_Top}`}
                          allowClear
                          placeholder="Enter Project Site Name"
                          onChange={(e) =>
                            handleFormDataOnChange(
                              'projectSiteName',
                              e.target.value
                            )
                          }
                        />
                      </FormItem>
                    </div>
                  </Card>
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Select Project Manger
                          </div>
                        }
                        name="projectHeadId"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Select
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          showSearch
                          allowClear={true}
                          optionFilterProp="children"
                          placeholder="Select Project Manger"
                          onSearch={debounceFetcherUserId}
                          onChange={(value) =>
                            handleFormDataOnChange('projectHeadId', value)
                          }
                          filterOption={(input, option) => {
                            return option?.children
                              ?.toString()
                              ?.toLowerCase()
                              ?.includes(input?.toLowerCase());
                          }}
                        >
                          {all_users_List?.map((item, index) => {
                            return (
                              <Option value={item.id} key={index}>
                                {`${item?.givenName} (${item.email})`}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </div>
                  </Card>
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Select the BU
                          </div>
                        }
                        name="buId"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Select
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          showSearch
                          allowClear={true}
                          optionFilterProp="children"
                          placeholder="Select BU"
                          onSearch={debounceFetcherBuId}
                          onChange={(value) =>
                            handleFormDataOnChange('buId', value)
                          }
                          filterOption={(input, option) => {
                            return option?.children
                              ?.toString()
                              ?.toLowerCase()
                              ?.includes(input?.toLowerCase());
                          }}
                        >
                          {bu_MasterList?.map((item, index) => {
                            return (
                              <Option value={item.id} key={index}>
                                {`${item?.buName}`}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </div>
                  </Card>
                  {/**SBU */}
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={<div className={styles.card_title}>SBU</div>}
                      >
                        <Select
                          value={selectedSbu}
                          disabled
                          placeholder="Select BU"
                        >
                          {selectedBuObj?.Sbus && (
                            <Option value={selectedBuObj.Sbus.id}>
                              {selectedBuObj.Sbus.name}
                            </Option>
                          )}
                        </Select>
                      </FormItem>
                    </div>
                  </Card>
                  {/**SBG */}
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={<div className={styles.card_title}>SBG</div>}
                      >
                        <Select
                          value={selectedSbg}
                          disabled
                          placeholder="Select BU"
                        >
                          {selectedBuObj?.Sbus?.Sbg && (
                            <Option value={selectedBuObj.Sbus.Sbg.id}>
                              {selectedBuObj.Sbus.Sbg.name}
                            </Option>
                          )}
                        </Select>
                      </FormItem>
                    </div>
                  </Card>
                  <div style={{ marginTop: '20px' }}>
                    <FormItem>
                      <Space
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          justifyItems: ' center'
                        }}
                      >
                        <Button
                          loading={create_or_update_project_siteLoading}
                          className={`${styles.ExceptionalApproval_button}`}
                          htmlType="submit"
                          size="small"
                        >
                          Save
                        </Button>

                        <Button
                          className={`${styles.cancel_rejectModal_button}`}
                          size="small"
                          onClick={() => history.push('/project-site-flow')}
                        >
                          Cancel
                        </Button>
                      </Space>
                    </FormItem>
                  </div>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </Spin>
    </CustomLayout>
  );
}
export default CreateProjectSiteFlows;

// import React, { useState, useEffect, useMemo } from 'react';
// import CustomLayout from '@/common/Layout';
// import { TabTitle } from '../../../../../../utilities/helpers';
// import { useDispatch, useSelector } from 'react-redux';
// import { Button, Card, Form, Space, Row, Spin, Input, Select } from 'antd';
// import styles from './index.module.less';
// import FormItem from 'common/FormItem';
// import { history } from '@/app/history';
// import {
//   get_all_users,
//   create_or_update_project_site,
//   get_BU_Master
// } from '../../../../redux/slice';
// import { debounce } from 'lodash';
// import FormData from 'form-data';

// const { Option } = Select;

// function CreateProjectSiteFlows() {
//   TabTitle('Gift Register - Create New RO Flow');

//   const [form] = Form.useForm();

//   const dispatch = useDispatch();

//   const [formValues, setFormValues] = useState({});
//   const [allUsersSearch, setAllUsersSearch] = useState('');
//   const [locationName, setLocationName] = useState('');
//   const [locationAddress, setLocationAddress] = useState('');
//   const [buSearch, setBuSearch] = useState('');
//   const [selectedBu, setSelectedBu] = useState(null);
//   const [selectedSbu, setSelectedSbu] = useState(null);
//   const [selectedSbg, setSelectedSbg] = useState(null);

//   const {
//     get_all_usersLoading,
//     all_users_List,
//     create_or_update_project_siteLoading,
//     bu_MasterList
//   } = useSelector((state) => state.admin);

//   useEffect(() => {
//     const payload = {};
//     if (allUsersSearch) payload['search'] = allUsersSearch;
//     dispatch(get_all_users(payload));
//   }, [allUsersSearch]);

//   useEffect(() => {
//     const payload = {};
//     if (buSearch) payload['search'] = buSearch;
//     dispatch(get_BU_Master(payload));
//   }, [buSearch]);

//   const debounceFetcherUserId = useMemo(() => {
//     const loadOptions = (allUsersSearch) => {
//       setAllUsersSearch(allUsersSearch);
//     };
//     return debounce(loadOptions, 400);
//   }, []);

//   const debounceFetcherBuId = useMemo(() => {
//     const loadOptions = (buSearch) => {
//       setBuSearch(buSearch);
//     };
//     return debounce(loadOptions, 400);
//   }, []);

//   const handleFormDataOnChange = (slug, value) => {
//     setFormValues({
//       ...formValues,
//       [slug]: value
//     });
//   };

//   const onFinish = () => {
//     let formdata = new FormData();
//     formdata.append('name', formValues?.projectSiteName || '');
//     formdata.append('InchargeId', formValues?.projectHeadId || '');
//     formdata.append('BuMasterId', formValues?.buId || '');
//     dispatch(create_or_update_project_site(formdata)).then(function (response) {
//       if (response?.payload?.success) {
//         history.push('/project-site-flow');
//       }
//     });
//   };

//   return (
//     <CustomLayout>
//       <Spin spinning={get_all_usersLoading}>
//         <div style={{ marginTop: '50px' }}>
//           <Row className={`${styles.row_container_setting}`}>
//             <div className={`${styles.gift_container}`}>
//               <div className={`${styles.myGift_title_setting}`}>
//                 Add Project Site
//               </div>
//             </div>
//           </Row>
//           <div className={`${styles.container}`}>
//             <div className={`${styles.cardContainer}`}>
//               <Card className={`${styles.cardStyles_Container}`}>
//                 <Form
//                   form={form}
//                   layout="vertical"
//                   onFinish={onFinish}
//                   className={`${styles.formstyles}`}
//                 >
//                   <Card className={`${styles.cardStyles}`}>
//                     <div className={`${styles.card_content}`}>
//                       <FormItem
//                         label={
//                           <div className={`${styles.card_title}`}>
//                             Enter Project Site Name
//                           </div>
//                         }
//                         name="projectSiteName"
//                         rules={[
//                           {
//                             required: true,
//                             message: 'This is a required field'
//                           }
//                         ]}
//                         className={`${styles.select_styles}`}
//                       >
//                         <Input
//                           value={locationAddress}
//                           className={`${styles.margin_Top}`}
//                           allowClear
//                           placeholder="Enter Project Site Name"
//                           onChange={(e) =>
//                             handleFormDataOnChange(
//                               'projectSiteName',
//                               e.target.value
//                             )
//                           }
//                         />
//                       </FormItem>
//                     </div>
//                   </Card>
//                   <Card className={`${styles.cardStyles}`}>
//                     <div className={`${styles.card_content}`}>
//                       <FormItem
//                         label={
//                           <div className={`${styles.card_title}`}>
//                             Select Project Manager
//                           </div>
//                         }
//                         name="projectHeadId"
//                         rules={[
//                           {
//                             required: true,
//                             message: 'This is a required field'
//                           }
//                         ]}
//                         className={`${styles.select_styles}`}
//                       >
//                         <Select
//                           className={`${styles.margin_Top}`}
//                           style={{ marginBottom: '15px' }}
//                           showSearch
//                           allowClear={true}
//                           optionFilterProp="children"
//                           placeholder="Select Project Manager"
//                           onSearch={debounceFetcherUserId}
//                           onChange={(value) =>
//                             handleFormDataOnChange('projectHeadId', value)
//                           }
//                           filterOption={(input, option) => {
//                             return option?.children
//                               ?.toString()
//                               ?.toLowerCase()
//                               ?.includes(input?.toLowerCase());
//                           }}
//                         >
//                           {all_users_List?.map((item, index) => {
//                             return (
//                               <Option value={item.id} key={index}>
//                                 {`${item?.givenName} (${item.email})`}
//                               </Option>
//                             );
//                           })}
//                         </Select>
//                       </FormItem>
//                     </div>
//                   </Card>
//                   <Card className={`${styles.cardStyles}`}>
//                     <div className={`${styles.card_content}`}>
//                       <FormItem
//                         label={
//                           <div className={`${styles.card_title}`}>
//                             Select the BU
//                           </div>
//                         }
//                         name="buId"
//                         rules={[
//                           {
//                             required: true,
//                             message: 'This is a required field'
//                           }
//                         ]}
//                         className={`${styles.select_styles}`}
//                       >
//                         <Select
//                           className={`${styles.margin_Top}`}
//                           style={{ marginBottom: '15px' }}
//                           showSearch
//                           allowClear={true}
//                           optionFilterProp="children"
//                           placeholder="Select BU"
//                           onSearch={debounceFetcherBuId}
//                           onChange={(value) => {
//                             setSelectedBu(value);
//                             setSelectedSbu(null);
//                             setSelectedSbg(null);
//                             handleFormDataOnChange('buId', value);
//                           }}
//                           filterOption={(input, option) => {
//                             return option?.children
//                               ?.toString()
//                               ?.toLowerCase()
//                               ?.includes(input?.toLowerCase());
//                           }}
//                         >
//                           {bu_MasterList?.map((item, index) => {
//                             return (
//                               <Option value={item.id} key={index}>
//                                 {`${item?.buName}`}
//                               </Option>
//                             );
//                           })}
//                         </Select>
//                       </FormItem>
//                     </div>
//                   </Card>
//                   <Card className={`${styles.cardStyles}`}>
//                     <div className={`${styles.card_content}`}>
//                       <FormItem
//                         label={
//                           <div className={`${styles.card_title}`}>
//                             Select the SBU
//                           </div>
//                         }
//                         name="sbuId"
//                         rules={[
//                           {
//                             required: true,
//                             message: 'This is a required field'
//                           }
//                         ]}
//                         className={`${styles.select_styles}`}
//                       >
//                         <Select
//                           className={`${styles.margin_Top}`}
//                           style={{ marginBottom: '15px' }}
//                           showSearch
//                           allowClear={true}
//                           optionFilterProp="children"
//                           placeholder="Select SBU"
//                           value={selectedSbu}
//                           disabled={!selectedBu}
//                           onChange={(value) => {
//                             setSelectedSbu(value);
//                             setSelectedSbg(null);
//                             handleFormDataOnChange('sbuId', value);
//                           }}
//                           filterOption={(input, option) => {
//                             return option?.children
//                               ?.toString()
//                               ?.toLowerCase()
//                               ?.includes(input?.toLowerCase());
//                           }}
//                         >
//                           {selectedBu &&
//                             bu_MasterList
//                               .find((bu) => bu.id === selectedBu)
//                               ?.Sbus?.map((item, index) => {
//                                 return (
//                                   <Option value={item.id} key={index}>
//                                     {`${item?.name}`}
//                                   </Option>
//                                 );
//                               })}
//                         </Select>
//                       </FormItem>
//                     </div>
//                   </Card>
//                   <Card className={`${styles.cardStyles}`}>
//                     <div className={`${styles.card_content}`}>
//                       <FormItem
//                         label={
//                           <div className={`${styles.card_title}`}>
//                             Select the SBG
//                           </div>
//                         }
//                         name="sbgId"
//                         rules={[
//                           {
//                             required: true,
//                             message: 'This is a required field'
//                           }
//                         ]}
//                         className={`${styles.select_styles}`}
//                       >
//                         <Select
//                           className={`${styles.margin_Top}`}
//                           style={{ marginBottom: '15px' }}
//                           showSearch
//                           allowClear={true}
//                           optionFilterProp="children"
//                           placeholder="Select SBG"
//                           value={selectedSbg}
//                           disabled={!selectedSbu}
//                           onChange={(value) => {
//                             setSelectedSbg(value);
//                             handleFormDataOnChange('sbgId', value);
//                           }}
//                           filterOption={(input, option) => {
//                             return option?.children
//                               ?.toString()
//                               ?.toLowerCase()
//                               ?.includes(input?.toLowerCase());
//                           }}
//                         >
//                           {selectedSbu &&
//                             bu_MasterList
//                               .find((bu) => bu.id === selectedBu)
//                               ?.Sbus?.find((sbu) => sbu.id === selectedSbu)
//                               ?.Sbg?.map((item, index) => {
//                                 return (
//                                   <Option value={item.id} key={index}>
//                                     {`${item?.name}`}
//                                   </Option>
//                                 );
//                               })}
//                         </Select>
//                       </FormItem>
//                     </div>
//                   </Card>
//                   <div style={{ marginTop: '20px' }}>
//                     <FormItem>
//                       <Space
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'center',
//                           justifyItems: 'center'
//                         }}
//                       >
//                         <Button
//                           loading={create_or_update_project_siteLoading}
//                           className={`${styles.ExceptionalApproval_button}`}
//                           htmlType="submit"
//                           size="small"
//                         >
//                           Save
//                         </Button>
//                         <Button
//                           className={`${styles.cancel_rejectModal_button}`}
//                           size="small"
//                           onClick={() => history.push('/project-site-flow')}
//                         >
//                           Cancel
//                         </Button>
//                       </Space>
//                     </FormItem>
//                   </div>
//                 </Form>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </Spin>
//     </CustomLayout>
//   );
// }

// export default CreateProjectSiteFlows;
